import React from 'react';
import PropTypes from 'prop-types';
import InputList from '../../input-list/InputList';
import './GridInputPrompts.css';

const AddTablePrompt = (props) => {
  let handleSubmit = (receivedValues) => {
    let rows = (receivedValues.values[props.formId + "-add-table-rows"]) ?
      receivedValues.values[props.formId + "-add-table-rows"] :
      null;
    
    let columns = (receivedValues.values[props.formId + "-add-table-columns"]) ?
      receivedValues.values[props.formId + "-add-table-columns"] :
      null;

    props.handleSubmit(rows, columns);
  }

  let inputListArray = [
    {
      label: 'Rows',
      type: 'number',
      id: props.formId + '-add-table-rows',
      required: true
    },
        {
      label: 'Columns',
      type: 'number',
      id: props.formId + '-add-table-columns',
      required: true
    },
    {
      type: 'button',
      value: 'Cancel',
      className: 'prompt__button--cancel',
      onClick: props.handleCancel
    },
    {
      type: 'submit',
      value: 'Add Table',
      className: 'button'
    }
  ];

  let promptContent = (props.isShowing) ?
    <span className="prompt__content">
      <InputList
        formId={props.formId}
        inputs={inputListArray}
        onSubmit={(receivedValues) => handleSubmit(receivedValues)}
      />
    </span> :
    null;

  return (
    <span className="add-table-prompt">
      {promptContent}
    </span>
  );
}

AddTablePrompt.propTypes = {
  formId: PropTypes.string.isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isShowing: PropTypes.bool.isRequired
}

export { AddTablePrompt }